import { useDispatch } from 'react-redux';
import { setUserReducer } from './../Redux/Reducers/userReducer';
import { setShopReducer } from './../Redux/Reducers/shopReducer';
import { setCategories } from './../Redux/Reducers/shopReducer';
import { setGoodsReducer } from './../Redux/Reducers/goodsReducer';
import { Axios } from './axios';
import axios from 'axios';

import { useTranslation } from 'react-i18next';

export const useOAuthWebApp = () => {

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    function objectToFormData(obj) {
        const formData = new FormData();
        Object.keys(obj).forEach(key => formData.append(key, obj[key]));
        return formData;
    }

    const OAuthWebApp = async (user, setShopIDSearchGoods) => {
        const formData = objectToFormData({
            // userId: user.userid,
            // storeId: user.shopid,
            // last_name: user.last_name,
            // first_name: user.first_name,
            // username: user.username !== null && user.username !== undefined ? user.username : '',
            ...user,
            language_code: window.Telegram.WebApp.initDataUnsafe.user.language_code,
            hash: window.Telegram.WebApp.initData,
            bootstrap: 1
        });

        try {
            // const { data } = await axios.post('https://jt.webappz.org/api/user/login/webapp-telegram', formData);
            const { data } = await Axios.post('/oauth/webapp', formData);

            if(data.status === undefined || data.status !== 200) {
                return { status: 'error', message: data.message }
            }

            window.__WEBAPPZ_CATALOG_BOOTSTRAP__ = {
                shopid: String(data.shopid),
                goods: data.bootstrap?.goods?.status === 'success',
                categories: data.bootstrap?.categories?.status === 'success'
            };

            dispatch(setUserReducer({
                userid: user.userid,
                first_name: user.first_name,
                last_name: user.last_name,
                username: user.username,
                token: data.token,
                shopid: data.shopid,
                t: data.settings.t,
                f: data.settings.f,
                language_code: data.language_code,
                wallet_address: data.wallet_address,
            }));

            setShopIDSearchGoods(data.shopid);

            i18n.changeLanguage(data.language_code);

            dispatch(setShopReducer({
                orderClone: data.orderClone,
                settings: data.settings
            }));

            if (data.bootstrap?.goods?.status === 'success' && Array.isArray(data.bootstrap.goods.items)) {
                const goods = data.bootstrap.goods.items.map((item) => ({
                    ...item,
                    sizes: item.sizes === null || item.sizes === undefined || item.sizes === '' || item.sizes === '[]' || item.sizes === '[""]'
                        ? '0'
                        : item.sizes
                }));

                dispatch(setGoodsReducer({ ...goods }));
            }

            if (data.bootstrap?.categories?.status === 'success' && Array.isArray(data.bootstrap.categories.categories)) {
                dispatch(setCategories({ ...data.bootstrap.categories.categories }));
            }

            var style = document.createElement('style');

            style.textContent = `
                .mainButton, .mainButton:hover, .mainButton:active, .mainButton:focus {
                    ${data.settings.colorThemeButton.slice(0, -1)} !important;
                }
                
                .mainText {
                    color: ${data.settings.text_cost !== 0 ? data.settings.text_cost : ''} !important;
                    font-family: "CostFont", sans-serif;
                }
                
                .mainBorder {
                    border: 1px solid ${data.settings.colorThemeButton.split(';')[0].split(':')[1]} ${data.settings.colorThemeButton.split(';')[0].split(':')[1].includes('!important') ? '' : ' !important'};
                }
                
                ::-webkit-scrollbar {
                    width: 4px;  /* Ширина скроллбара */
                    height: 4px;
                }
                
                ::-webkit-scrollbar-track {
                    background: var(--tg-theme-bg-color);
                }
                
                ::-webkit-scrollbar-thumb {
                    background-color: ${data.settings.colorThemeButton.split(';')[0].split(':')[1]};  /* Цвет ползунка */
                    border-radius: 10px;  /* Радиус закругления */
                    border: 1px solid ${data.settings.colorThemeButton.split(';')[0].split(':')[1]};  /* Обводка ползунка, чтобы создать отступ */
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: ${data.settings.colorThemeButton.split(';')[0].split(':')[1]};  /* Цвет ползунка при наведении */
                }
            `;

            if(window.Telegram !== undefined) {
                window.Telegram.WebApp.MainButton.color = data.settings.TGMainButtonColor;
            }

            if(data.settings.mainBGAppColor !== null) {
                style.textContent += `
                    html, body, #root, .mainBgColor, .form-control, div {
                        background: ${data.settings.mainBGAppColor} !important;
                    }
                `;
            } else {
                style.textContent += `
                    .MuiPaper-root {
                        color: var(--tg-theme-text-color) !important;
                    }
                `;
            }

            document.head.appendChild(style);

            return data;
        }
        catch (err) {
            return { success: 0, message: 'Server Error!' };
        }
    };

    const ConnectWalletAddress = async(UserSession, wallet) => {
        const formData = objectToFormData({
            userID: UserSession.userid,
            shopID: UserSession.shopid,
            token: UserSession.token,
            walletAddress: wallet,
            hash: window.Telegram.WebApp.initData,
        });

        const { data } = await Axios.post('connect/payment/telegram-wallet', formData);

        return data;
    }

    return { OAuthWebApp, ConnectWalletAddress };
};
